import { takeEvery, put, select, take } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { transferUserToOtherOrg, subscribeToProTrack } from '../actions'
import { getQueries } from 'store/entities/localSettings/selectors'

export function* transfer() {
  const queries = yield select(getQueries)
  const proTrackLevelId = queries.get('proTrackLevelId')

  if (proTrackLevelId) {
    yield put(subscribeToProTrack({ proTrackLevelId, isSubscriptionFromEmail: true }))
  } else {
    yield put(push('/on-boarding-landing'))
    setTimeout(() => location.reload())
  }
}

export default function* transferUser() {
  yield takeEvery(transferUserToOtherOrg.success.toString(), transfer)
}
